import { render, staticRenderFns } from "./IconGoogleChevronLeft.vue?vue&type=template&id=672f1f7f&"
import script from "./IconGoogleChevronLeft.vue?vue&type=script&lang=ts&"
export * from "./IconGoogleChevronLeft.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports